import React from "react";
import { useTranslation } from "react-i18next";
import { AutoTextSize } from "auto-text-size";
import "./workexperience.css";

export default function CompanyOverview({
  id,
  name,
  image,
  imageHeight,
  url,
  mainColor,
  secondColor,
}) {
  const { t } = useTranslation();

  return (
    <div className="overview-container">
      <img
        style={{ height: imageHeight }}
        src={`/images/companies/${image}`}
        alt={id}
      />
      <div className="overview-content">
        <AutoTextSize className="auto-text-size" maxFontSizePx={24}>
          {name}
        </AutoTextSize>
        <AutoTextSize className="auto-text-size" maxFontSizePx={20}>
          {t(`experience.${id}.position`)}
        </AutoTextSize>
        <div
          className="timeline"
          style={{
            background: mainColor,
          }}
        >
          <div>{t(`experience.${id}.start`)}</div>
          <div>{t(`experience.${id}.end`)}</div>
        </div>
      </div>
    </div>
  );
}
